export var TargetGroup;
(function (TargetGroup) {
    TargetGroup[TargetGroup["None"] = 0] = "None";
    TargetGroup[TargetGroup["Homeless"] = 1] = "Homeless";
    TargetGroup[TargetGroup["Disability"] = 2] = "Disability";
    TargetGroup[TargetGroup["MentalHealth"] = 3] = "MentalHealth";
    TargetGroup[TargetGroup["SubstanceAbuseRehabilitation"] = 4] = "SubstanceAbuseRehabilitation";
    TargetGroup[TargetGroup["ReleasedPrisoner"] = 5] = "ReleasedPrisoner";
    TargetGroup[TargetGroup["Overindebted"] = 6] = "Overindebted";
    TargetGroup[TargetGroup["Other"] = 7] = "Other";
})(TargetGroup || (TargetGroup = {}));
